﻿'use strict';

angular.module('ntmApp').factory('GridControl', ['uiGridExporterConstants', 'uiGridExporterService', function (uiGridExporterConstants, uiGridExporterService) {

    function GridControl(scope, PrintingService, gridOptions) {

        var self = this;
        var onColumnVisibilityChangedEvent = null;

        self.applyData = function (data) {

            self.gridOptions.data = data;
        };

        self.hasData = function () {
            return self.gridOptions.data && self.gridOptions.data.length > 0;
        };

        self.exportToCSV = function () {
            var grid = self.gridApi.grid;
            var rowTypes = uiGridExporterConstants.ALL;
            var colTypes = uiGridExporterConstants.ALL;
            uiGridExporterService.csvExport(grid, rowTypes, colTypes);
        };

        self.exportVisibleDataToCSV = function () {
            var grid = self.gridApi.grid;
            var rowTypes = uiGridExporterConstants.VISIBLE;
            var colTypes = uiGridExporterConstants.VISIBLE;
            uiGridExporterService.csvExport(grid, rowTypes, colTypes);
        };

        self.exportToPDF = function (title) {
            PrintingService.export(title, self.gridOptions.columnDefs, self.gridOptions.data);
        };

        self.exportVisibleDataToPDF = function (title) {

            var rows = self.gridApi.core.getVisibleRows().map(function (gridRow) {
                return gridRow.entity;
            });

            PrintingService.export(
                title,
                self.gridOptions.columnDefs.filter(function (columnDef) {
                    return columnDef.visible;
                }),
                rows);
        };
        
        self.onColumnVisibilityChanged = function (event) {
            onColumnVisibilityChangedEvent = event;
        };

        self.handleWindowResize = function () {

            if (self.gridApi) {
                self.gridApi.core.handleWindowResize();
            }
        };

        function getVisibleColumnListAsJson() {
            
            var columnPreferences = {};

            self.gridOptions.columnDefs.forEach(function (item) {
                columnPreferences[item.name] = item.visible ? true : false;
            });

            return JSON.stringify(columnPreferences);
        }

        function initialize() {

            self.gridOptions = gridOptions || {};
            self.gridOptions.onRegisterApi = function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.core.on.columnVisibilityChanged(scope, function () {
                    
                    if (onColumnVisibilityChangedEvent) {
                        onColumnVisibilityChangedEvent(getVisibleColumnListAsJson());
                    }

                });
            };

        }

        initialize();
    }

    return (GridControl);
}]);